import { NotificationToast } from './NotificationToast';
import { useNotification } from '../context/NotificationContext';

export function GlobalNotificationToast() {
  const { toast, closeNotification } = useNotification();
  return (
    <NotificationToast
      open={toast.open}
      title={toast.title}
      message={toast.message}
      actions={toast.actions}
      onClose={closeNotification}
      severity={toast.severity}
      position={toast.position}
      duration={toast.duration}
    />
  );
}
